var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 2.15c.47 0 .85.38.85.85v1.15h6.3V3a.85.85 0 0 1 1.7 0v1.15H19A2.85 2.85 0 0 1 21.85 7v12A2.85 2.85 0 0 1 19 21.85H5A2.85 2.85 0 0 1 2.15 19V7A2.85 2.85 0 0 1 5 4.15h2.15V3c0-.47.38-.85.85-.85m-.85 3.7H5A1.15 1.15 0 0 0 3.85 7v12c0 .635.515 1.15 1.15 1.15h14A1.15 1.15 0 0 0 20.15 19V7A1.15 1.15 0 0 0 19 5.85h-2.15V7a.85.85 0 1 1-1.7 0V5.85h-6.3V7a.85.85 0 1 1-1.7 0zm-1 5.15c0-.47.38-.85.85-.85h10a.85.85 0 1 1 0 1.7H7a.85.85 0 0 1-.85-.85",
  clipRule: "evenodd"
})));
export default SvgCalendar;